import {Hal} from './hal.model';
import {PagedHal} from './paged-hal.model';

export interface DocumentLastAction {
  type: string;
  occurredAt?: Date;
  actorType?: string;
  actorName?: string;
}

export class DocumentHal extends Hal {
  identification: string;
  caseId: string;
  caseName: string;
  formIdentifier: string;
  title: string;
  description: string;
  lastUpdated: Date;
  lastUpdatedBy: string;
  fileMetadata: {
    fileId: string;
    name: string;
    description: string;
    mimeType: string;
    category: string;
    size: string;
    extension: string;
  };
  position: number;
  state: string;
  renderPreviewEnabled: boolean;
  saveProgressEnabled: boolean;
  completeDataCapturingEnabled: boolean;
  sealed: boolean;
  sealedDate?: Date;
  sealedBy?: string;
  lastAction?: DocumentLastAction;
  type?: string;

  constructor(data: any) {
    super(data);
    this.identification = data.identification;
    this.caseId = data.caseId;
    this.caseName = data.caseName;
    this.formIdentifier = data.formIdentifier;
    this.title = data.title;
    this.description = data.description;
    this.lastUpdated = new Date(data.lastUpdated);
    this.lastUpdatedBy = data.lastUpdatedBy;
    this.fileMetadata = data.fileMetadata;
    this.position = data.position;
    this.state = data.state;
    this.renderPreviewEnabled = !!data.renderPreviewEnabled;
    this.saveProgressEnabled = !!data.saveProgressEnabled;
    this.completeDataCapturingEnabled = !!data.completeDataCapturingEnabled;
    this.sealed = !!data.sealed;
    this.sealedDate = data.sealedDate ? new Date(data.sealedDate) : undefined;
    this.sealedBy = data.sealedBy;
    this.lastAction = data.lastAction ? {
      ...data.lastAction,
      occurredAt: data.lastAction.occurredAt ? new Date(data.lastAction.occurredAt) : undefined
    } : undefined;
    this.type = data.type;
  }

  hasFileId(): boolean {
    return this.fileMetadata && !!this.fileMetadata.fileId;
  }
}

export class PagedDocumentHal extends PagedHal {
  _embedded?: Embedded;

  constructor(data: any) {
    super(data);
    this._embedded = new Embedded(data._embedded);
  }
}

class Embedded {
  documents?: DocumentHal[] = [];

  constructor(data: any) {
    this.documents = data.documents.map((data: any) => new DocumentHal(data));
  }
}

export class DocumentCollectionHal extends Hal {
  _embedded?: Embedded;

  constructor(data: any) {
    super(data);
    if (data._embedded) {
      this._embedded = new Embedded(data._embedded);
    }
  }
}
